import * as React from "react";
import { cloneElement, useState } from "react";
import { createPortal } from "react-dom";
import { ControlPosition, IControl, MapInstance, useControl } from "react-map-gl";
import style from "./CustomControl.module.css";

class CustomControlClass implements IControl {
    _map: MapInstance | null = null;
    _container: HTMLElement | null = null;
    _redraw: () => void;

    constructor(redraw: () => void) {
        this._redraw = redraw;
    }

    onAdd(map: MapInstance) {
        this._map = map;
        map.on("move", this._redraw);

        this._container = document.createElement("div");
        this._container.className = style.container;
        this._redraw();

        return this._container;
    }

    onRemove() {
        this._container!.remove();
        this._map!.off("move", this._redraw);
        this._map = null;
    }

    getMap() {
        return this._map!;
    }

    getElement() {
        return this._container!;
    }
}

function CustomControl({ children, position }: ICustomControlProps) {
    const [, setVersion] = useState(0);

    const ctrl = useControl<CustomControlClass>(() => {
        const forceUpdate = () => setVersion(v => v + 1);
        return new CustomControlClass(forceUpdate);
    }, {
        position: position,
    });

    const map = ctrl.getMap();

    return map && createPortal(cloneElement(children, { map }), ctrl.getElement());
}

export default CustomControl;

interface ICustomControlProps {
    children: React.ReactElement;
    position?: ControlPosition;
}